import { Route } from "react-router-dom";
import { GuestRoute } from "./GuestRoute";
import Login from "@/features/auth/pages/Login";
import Register from "@/features/auth/pages/Register";
import ForgotPassword from "@/features/auth/pages/ForgotPassword";
import VerifyEmail from "@/features/auth/pages/VerifyEmail";
import CompleteProfilePage from "@/features/auth/pages/CompleteProfilePage";
import ResetPassword from "@/features/auth/pages/ResetPassword";

export const authRoutes = (
    <>
        <Route path="/login" element={<GuestRoute><Login /></GuestRoute>} />
        <Route path="/register" element={<GuestRoute><Register /></GuestRoute>} />
        <Route path="/forgot-password" element={<GuestRoute><ForgotPassword /></GuestRoute>} />
        <Route path="/verify-email" element={<GuestRoute><VerifyEmail /></GuestRoute>} />
        {/* Not wrapped in GuestRoute — user is Firebase-authenticated but profile incomplete */}
        <Route path="/complete-profile" element={<CompleteProfilePage />} />
        {/* Not wrapped in GuestRoute — user just authenticated via phone OTP to reset password */}
        <Route path="/reset-password" element={<ResetPassword />} />
    </>
);

